import { h } from 'preact';
import { InputField } from 'DesignSystem';
import translate from 'helpers/utils/translate';

type CreateListProps = {
    error: string;
    listName: string;
    shouldValidate: boolean;
    setListName: (name: string) => void;
};
const CreateList = ({ error, listName, shouldValidate, setListName }: CreateListProps) => {
    return (
        <InputField
            req
            type="text"
            label={translate('Create list placeholder')}
            id="list-name"
            value={listName}
            shouldValidate={shouldValidate}
            valid={!error}
            validation={{
                body: <p>{error}</p>,
                id: 'list-name',
            }}
            onChange={e => setListName(e.target.value)}
        />
    );
};

export default CreateList;
